"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShakaSupportedFormats = void 0;
var player_base_1 = require("@24i/player-base");
var player_html5_1 = require("@24i/player-html5");
var shaka_player_1 = __importDefault(require("shaka-player"));
var ShakaSupportedFormats = (function (_super) {
    __extends(ShakaSupportedFormats, _super);
    function ShakaSupportedFormats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShakaSupportedFormats.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var support, screenHeight, _a, _b, _c, _d, _e, _f, _g, _h;
            var _this = this;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4, shaka_player_1.default.Player.probeSupport()];
                    case 1:
                        support = _j.sent();
                        support.media[player_base_1.MIME_TYPE.MP3_AUDIO] = true;
                        screenHeight = window.screen.height;
                        this.manifest = [];
                        if (!support.manifest[player_base_1.MIME_TYPE.DASH]) return [3, 3];
                        _b = (_a = this.manifest).push;
                        return [4, player_base_1.registerDash(screenHeight, function (c) { return _this.checkCodec(c, support); }, function () { return _this.detectWidevine(support); }, function () { return _this.detectPlayReady(support); }, false)];
                    case 2:
                        _b.apply(_a, [_j.sent()]);
                        _j.label = 3;
                    case 3:
                        if (!support.manifest[player_base_1.MIME_TYPE.SMOOTH_STREAM]) return [3, 5];
                        _d = (_c = this.manifest).push;
                        return [4, player_base_1.registerSmoothStreaming(screenHeight, function (c) { return _this.checkCodec(c, support); }, function () { return _this.detectWidevine(support); }, function () { return _this.detectPlayReady(support); }, false)];
                    case 4:
                        _d.apply(_c, [_j.sent()]);
                        _j.label = 5;
                    case 5:
                        if (!support.manifest[player_base_1.MIME_TYPE.HLS]) return [3, 7];
                        _f = (_e = this.manifest).push;
                        return [4, player_base_1.registerHls(screenHeight, function (c) { return _this.checkCodec(c, support); }, function () { return _this.detectFairPlay(support); }, false)];
                    case 6:
                        _f.apply(_e, [_j.sent()]);
                        _j.label = 7;
                    case 7:
                        _h = (_g = this.manifest).push;
                        return [4, player_base_1.registerNative(screenHeight, function (f) { return _this.checkType(f, support); }, function (c) { return _this.checkCodec(c, support); }, false)];
                    case 8:
                        _h.apply(_g, [_j.sent()]);
                        return [4, _super.prototype.initialize.call(this)];
                    case 9:
                        _j.sent();
                        return [2];
                }
            });
        });
    };
    ShakaSupportedFormats.prototype.checkType = function (format, support) {
        return support.media[format] || false;
    };
    ShakaSupportedFormats.prototype.checkCodec = function (codec, support) {
        return player_html5_1.buildCodecMimeTypes(codec).some(function (mime) { return support.media[mime]; });
    };
    ShakaSupportedFormats.prototype.detectWidevine = function (support) {
        var drmSupport = support.drm[player_base_1.DRM_TYPE.WIDEVINE];
        if (!drmSupport)
            return Promise.resolve(undefined);
        return Promise.resolve({
            name: player_base_1.DRM_NAME.WIDEVINE,
            keySystems: [player_base_1.DRM_TYPE.WIDEVINE],
            offline: drmSupport.persistentState,
            providers: this.buildWidevineProviders(),
        });
    };
    ShakaSupportedFormats.prototype.buildWidevineProviders = function () {
        return [player_base_1.IntegrationTypes.Comcast];
    };
    ShakaSupportedFormats.prototype.detectPlayReady = function (support) {
        var drmSupport = support.drm[player_base_1.DRM_TYPE.PLAYREADY];
        if (!drmSupport)
            return Promise.resolve(undefined);
        return Promise.resolve({
            name: player_base_1.DRM_NAME.PLAYREADY,
            keySystems: [player_base_1.DRM_TYPE.PLAYREADY],
            offline: drmSupport.persistentState,
            providers: [],
        });
    };
    ShakaSupportedFormats.prototype.detectFairPlay = function (support) {
        var possibleKeySystems = [
            player_base_1.DRM_TYPE.FAIRPLAY,
            player_base_1.DRM_TYPE.FAIRPLAY_1,
            player_base_1.DRM_TYPE.FAIRPLAY_2,
            player_base_1.DRM_TYPE.FAIRPLAY_3,
        ];
        var keySystems = possibleKeySystems.filter(function (ks) { return support.drm[ks]; });
        if (keySystems.length === 0)
            return Promise.resolve(undefined);
        var offline = possibleKeySystems.some(function (ks) { var _a; return (_a = support.drm[ks]) === null || _a === void 0 ? void 0 : _a.persistentState; });
        return Promise.resolve({
            name: player_base_1.DRM_NAME.FAIRPLAY,
            keySystems: keySystems,
            offline: offline,
            providers: [],
        });
    };
    return ShakaSupportedFormats;
}(player_base_1.BaseSupportedFormats));
exports.ShakaSupportedFormats = ShakaSupportedFormats;
//# sourceMappingURL=index.js.map